<template>
  <div>
    <base-header class="pb-6 pb-1 pt-5 pt-md-8 bg-gradient-custom" type="custom">
      <b-row>
        <b-col xl="5" md="6">
          <base-button icon type="primary" @click="redirectToForm">
            <span class="btn-inner--icon"><i class="ni ni-fat-add"></i></span>
            <span class="btn-inner--text">Nueva Organización</span>
          </base-button>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--5">
      <ReusableTable
        :title="tableTitle"
        :data="organizations"
        :columns="tableColumns"
        :actions="tableActions"
        :per-page="itemsPerPage"
        :total="totalOrganizations"
        :search-query="searchQuery"
        @fetch-data="fetchOrganizations"
        @search="onSearch"
      >
        <template #column-ID_ORG="{ row }">
          <span class="font-weight-bold">{{ row.ID_ORG }}</span>
        </template>

        <template #icon-edit>
          <i class="fas fa-pencil-alt"></i>
        </template>
        <template #icon-delete>
          <i class="far fa-trash-alt"></i>
        </template>
      </ReusableTable>
    </b-container>

    <b-modal v-model="showDeleteModal" title="Confirmar Eliminación" size="">
      <div class="py-3 text-center">
        <i class="far fa-trash-alt me-5 ni-3 text-red"></i>
        <p v-if="organizationToDelete">
          ¿Estás seguro de eliminar esta organización:
          <strong>{{ organizationToDelete.NAME_ORG }}</strong>?
        </p>
        <p v-else>¿Estás seguro de eliminar esta organización?</p>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="danger" @click="confirmDelete">Eliminar</b-button>
        <b-button variant="secondary" @click="showDeleteModal = false">
          Cancelar
        </b-button>
      </template>
    </b-modal>
    <TokenExpiredModal :show="showTokenExpiredModal"> </TokenExpiredModal>
  </div>
</template>

<script>
import axios from "axios";
import ReusableTable from "./Tables/RegularTables/TablaReu.vue";
import TokenExpiredModal from "../components/TokenExpiredModal.vue";

export default {
  components: { ReusableTable, TokenExpiredModal },
  data() {
    return {
      organizations: [],
      totalOrganizations: 0,
      showDeleteModal: false,
      organizationToDelete: null,
      isLoading: true,
      showTokenExpiredModal: false,
      itemsPerPage: 10,
      currentPage: 1,
      searchQuery: "",
      tableTitle: "Listado de Organizaciones",
      tableColumns: [
        { prop: "ID_ORG", label: "ID" },
        { prop: "NAME_ORG", label: "Nombre" },
      ],
      tableActions: [
        {
          name: "edit",
          label: "Editar",
          class: "btn text-black",
          onClick: (row) => this.$router.push(`/OrgEdit/${row.ID_ORG}`),
        },
        {
          name: "delete",
          label: "Eliminar",
          class: "btn text-red",
          onClick: (row) => this.openDeleteModal(row),
        },
      ],
    };
  },
  watch: {
    currentPage() {
      this.fetchOrganizations();
    },
    searchQuery() {
      this.currentPage = 1;
      this.fetchOrganizations();
    },
  },
  methods: {
    async fetchOrganizations({ page, perPage, search } = {}) {
      this.isLoading = true;
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}/obtenerDatosORG`,
          {
            params: {
              page: page || this.currentPage,
              perPage: perPage || this.itemsPerPage,
              search: search || this.searchQuery,
            },
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.success) {
          this.organizations = response.data.data;
          this.totalOrganizations = response.data.total;
          this.currentPage = page || this.currentPage;
        } else {
          this.$notifications.addNotification({
            type: "danger",
            message: "Error al obtener datos",
          });
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.handleTokenExpired();
        } else {
          console.error("Error en la solicitud:", error.response);
          this.$notifications.addNotification({
            type: "danger",
            message: "Error al obtener datos",
          });
        }
      } finally {
        this.isLoading = false;
      }
    },
    onSearch(searchQuery) {
      this.searchQuery = searchQuery;
      this.fetchOrganizations();
    },
    openDeleteModal(row) {
      this.organizationToDelete = row;
      this.showDeleteModal = true;
    },
    async confirmDelete() {
      if (!this.organizationToDelete) return;
      try {
        const token = localStorage.getItem("token");
        const response = await axios.delete(
          `${process.env.VUE_APP_API_URL}/eliminarORG/${this.organizationToDelete.ID_ORG}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (response.data && response.data.success) {
          this.$notifications.addNotification({
            type: "success",
            message: "Organización eliminada correctamente",
          });
          if (this.organizations.length === 1 && this.currentPage > 1) {
            this.currentPage -= 1;
          }
          this.fetchOrganizations({ page: this.currentPage });
        } else {
          if (error.response && error.response.status === 401) {
            this.handleTokenExpired();
          } else {
            this.$notifications.addNotification({
              type: "danger",
              message: response.data && response.data.message ? response.data.message : "Error al eliminar la organización",
            });
          }
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.handleTokenExpired();
        } else {
          console.error("Error al eliminar la organización:", error);
          this.$notifications.addNotification({
            type: "danger",
            message: "Error al eliminar la organización",
          });
        }
      } finally {
        this.showDeleteModal = false;
        this.organizationToDelete = null;
      }
    },
    redirectToForm() {
      this.$router.push("/OrgAdd");
    },
    handleTokenExpired() {
      this.showTokenExpiredModal = true;
      setTimeout(() => {
        this.$router.push("/login");
      }, 3000);
    },
  },
  mounted() {
    this.fetchOrganizations();
  },
};
</script>